import store from "store";
import config from "config.js";
import { addJRR } from "core-module/services/api/actions";
import { addNewID } from "core-module/services/ids/actions";
import getVar from "core-module/tiny-functions/getVar";
import parseApiStatus from "core-module/services/api/parseApiStatus";
import * as api from "core-module/services/api";
import redirect from "common/functions/redirect";
import { isIosDevice, isNativeIosPlatform } from "../deviceInfo";

import { ApiUnreachable, InvalidToken } from "core-module/services/error";

const setUpUser = async function () {
  const pi = getVar("pi");
  const nativeIos = isNativeIosPlatform();
  const hw = getVar("hw");
  const offer = getVar("of");

  if (offer !== false) {
    window.localStorage.setItem("of", offer);
  }

  if (hw !== false && /^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$/.test(hw)) {
    store.dispatch(addNewID("hw", hw));
  }

  if (nativeIos && pi !== false && !/^[a-zA-Z0-9+./=_-]{2,512}$/.test(pi)) {
    throw new InvalidToken("Invalid sign-in callback.");
  }
  if (pi !== false && /^[a-zA-Z0-9+./=_-]{2,512}$/.test(pi)) {
    try {
      var piRes = await fetch(config.API.ADDRESS + "?pi=" + pi);
    } catch (e) {
      throw new ApiUnreachable(e.message);
    }

    const piData = await parseApiStatus(piRes);

    if (piData && "JRR" in piData) {
      store.dispatch(addJRR(piData.JRR));
    } else if (nativeIos) {
      throw new InvalidToken(
        "Your sign-in link has expired. Please sign in again."
      );
    }
  } else {
    const res = await api.fetchApi(
      "/?ph=a&target=b",
      "get",
      {},
      {
        Accept: "application/json",
      }
    );
    const isIos = await isIosDevice();

    // No credentials is normal on first launch. Let redirect() open sign-in
    // and attempt remembered Firebase authentication in that case.
    if (nativeIos && !res) {
      await redirect();
      return false;
    }

    if (nativeIos && res?.status === 401) {
      throw new InvalidToken("Please sign in again.");
    }

    if (res == null || (res?.status > 200 && !isIos)) {
      redirect();
    }
  }
};

export default setUpUser;
